/**
 * Minimum password length, checked before the form leaves the browser.
 *
 * Shopify's own floor is 5 characters, fixed on its side, and its error says so
 * — which contradicts the note under the field. Any input carrying
 * data-password-min is held to that length here instead: a shorter password
 * never reaches Shopify, so its "minimum is 5 characters" never shows.
 *
 * The message comes from the input's data-password-message, so the wording
 * lives in the locale file next to the note it has to agree with.
 */
(function () {
  var SELECTOR = '[data-password-min]';
  var ERROR_ATTR = 'data-password-error';

  function errorFor(input) {
    var id = input.id + '-length-error';
    var error = document.getElementById(id);
    if (error) return error;

    error = document.createElement('p');
    error.id = id;
    // Not .remark: that rule comes later in main.css and would turn it grey.
    error.className = 'remark__red';
    error.style.fontSize = '0.9em';
    error.setAttribute(ERROR_ATTR, '');
    error.setAttribute('role', 'alert');
    error.hidden = true;

    // After the field's wrapper, so it sits under the eye toggle rather than
    // inside the box the toggle is positioned against.
    var anchor = input.closest('.password-field') || input;
    anchor.parentNode.insertBefore(error, anchor.nextSibling);
    return error;
  }

  function tooShort(input) {
    var min = parseInt(input.dataset.passwordMin, 10);
    return min > 0 && input.value.length < min;
  }

  function show(input) {
    var error = errorFor(input);
    error.textContent = input.dataset.passwordMessage || '';
    error.hidden = false;
    input.setAttribute('aria-invalid', 'true');
    input.setAttribute('aria-describedby', error.id);
  }

  function clear(input) {
    var error = document.getElementById(input.id + '-length-error');
    if (error) error.hidden = true;
    input.removeAttribute('aria-invalid');
  }

  // Once a message is showing, take it away the moment the password is long
  // enough, rather than leaving the customer to guess whether it still applies.
  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches(SELECTOR)) return;
    if (!tooShort(input)) clear(input);
  });

  // On window, capture phase: ahead of every submit listener on the document,
  // Shopify's captcha script among them, which would otherwise take the form
  // over and post it itself.
  window.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || typeof form.querySelectorAll !== 'function') return;

      var short = Array.prototype.filter.call(form.querySelectorAll(SELECTOR), tooShort);
      if (!short.length) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      short.forEach(show);
      short[0].focus();
    },
    true
  );
})();
